import React, { useEffect, useState } from "react";
import Gallery from "@/components/Gallery";
import GalleryMarquee from "@/components/GalleryMarquee";
import { api } from "@/lib/api";

export default function GalleryPage() {
  const [marqueeItems, setMarqueeItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/media", { params: { skip: 0, limit: 24 } });
        setMarqueeItems(data.items || []);
      } catch (e) {
        console.error("Failed to load marquee items", e);
      }
    })();
  }, []);

  return (
    <>
      {marqueeItems.length > 0 && (
        <section className="px-2 md:px-4 lg:px-6 pt-10 lg:pt-16">
          <div className="text-center mb-6">
            <p className="font-accent text-3xl text-rose-300">défilent</p>
            <h2 className="font-serif text-3xl md:text-4xl text-rose-50">Nos instants en mouvement</h2>
          </div>
          <GalleryMarquee items={marqueeItems} direction="left" speed={4} />
          {marqueeItems.length > 4 && (
            <GalleryMarquee items={[...marqueeItems].reverse()} direction="right" speed={5} />
          )}
        </section>
      )}
      <Gallery />
    </>
  );
}
